import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import { events } from "../../utils/events";

import styles from "./scripture-link.css";

@customElement("bp-scripture-link")
export class ScriptureLink extends LitElement {
  static styles = styles;

  @property()
  reference?: string;

  handleClick(e: MouseEvent) {
    e.preventDefault();

    if (this.reference) events.requestScriptureOpen(this.reference);
  }

  render() {
    return html` <button @click="${this.handleClick}"><slot></slot></button> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-scripture-link": ScriptureLink;
  }
}
